// UserSelectDropdown.js
import React, {useState} from 'react';
import {Box, Button, ListItem, Menu, MenuItem} from '@mui/material';
import {Person2Rounded} from "@mui/icons-material";

function UserSelectDropdown({userIDS, selectedUserName, onUserSelect, user}) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (userId, userName) => {
        onUserSelect(userId, userName); // Pass both userId and userName
        handleClose();
    };
    return (
        < ListItem sx={{
            justifyContent: 'center',
            margin: 1,
        }}>
            <Button variant={"contained"} startIcon={<Person2Rounded/>} onClick={handleClick}>
                {selectedUserName}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem
                    onClick={() => handleSelect(user, "Deine Daten")}
                >
                    {user}
                </MenuItem>
                {userIDS.map(item => {
                    const displayName = item.name || item.email || item.id;
                    return (
                        <MenuItem
                            key={item.id}
                            onClick={() => handleSelect(item.id, displayName)}
                        >
                            {displayName}
                        </MenuItem>
                    );
                })}
            </Menu>
        </ListItem>
    );
}

export default UserSelectDropdown;
